import { type PortalFactory } from "@mantine/core/lib/components/Portal/Portal";
import { componentWrapper } from "../../utilities";
import { Portal as MantinePortal } from "@mantine/core";
import { IProps } from "./portal.types";

const Portal = componentWrapper<PortalFactory, IProps>("Portal", (props, ref) => {
    return <MantinePortal ref={ref} {...props} />;
});

export { Portal };
